#include <common>
#include <uv_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>

varying vec3 vWorldPosition;
varying vec2 vUv;

void main() {
    vUv = uv;

    vec4 transformed = vec4(position, 1.0);
    vec4 mvPosition = modelViewMatrix * transformed;
    vec4 worldPosition = modelMatrix * transformed;

    vWorldPosition = worldPosition.xyz;

    #include <logdepthbuf_vertex>
    #include <clipping_planes_vertex>

    gl_Position = projectionMatrix * mvPosition;
}
